import { IMessaggioHelp } from "./nica-help.component";



//Puoi Aggiungere/Rimuovere i messaggi da qui

export const messaggiHelp : IMessaggioHelp[]=[
    {
        id:0,
        cm:"minLetterePassword",
        descrizione:"La password deve contenere almeno 6 caratteri"
    },
    {
        id:1,
        cm:"aiutoVittoria",
        descrizione:"<img width='80px' src='assets/images/vittoria.jpeg'/> <span><strong>Salve sono Vittoria, in cosa posso esserle di aiuto </strong></span>"
    },
    {
        id:2,
        cm:"carattereSpecialePassword",
        descrizione: "La password deve contenere alemno un carattere speciale"
    },
    {
        id:4,
        cm:"helpNica",
        descrizione:
                  `<img width='80px' src='https://www.smau.it/Imported/PartnerProfile/image-thumb__16932__partner-show-image/logo_nica_alta_def_43257.jpeg'> 
                   <span><b>Benvenuto</b>, come possiamo aiutarla ?</span>`
                }      
]
